import {
  useDashboardUIActions,
  useDashboardUIContext,
} from "@contexts/dashboardUI";
import { useProjectContext } from "@contexts/projects";
import { Fragment, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { HelpModalText } from "./HelpModalText";
import { helperModalScreens, helperModalTexts } from "@utils/cardTexts";

const Item = ({ item }) => {
  const [open, isOpen] = useState(false)

  return <div className="item">
    <div className="flex align-center gap-8 item-header">
      <button
        className={`accordion-toggle ${open ? "active" : ""}`}
        onClick={() => isOpen(!open)}
      ></button>
      <span className="title">{item.title}</span>
    </div>
    <div className={`description ${open ? "active" : ""}`}>
      {item.description.split('\n').map((line, idx) => (
        <Fragment key={idx}>
          {line}
          <br />
        </Fragment>
      ))}
    </div>
  </div>
}

const HelpModal = () => {
  const { pathname } = useLocation();
  const [helpText, setHelpText] = useState({})
  const { showHelpModal } = useDashboardUIContext();
  const { toggleHelpModal } = useDashboardUIActions();

  useEffect(() => {
    setHelpText(HelpModalText(pathname.split('/')[2]))
  }, [pathname])


  return (
    <div className={showHelpModal ? "offcanvas active" : "offcanvas"}>
      <div className="offcanvas-container">
        <hgroup className="offcanvas-header">
          <h2>Ajuda</h2>
          <button onClick={toggleHelpModal}>
            <i
              className="icon icon-width-24 icon-times background-accent"
              aria-hidden={true}
            ></i>
          </button>
        </hgroup>
        <h2 className="helper-header">Descrição dos Cards</h2>
        <div className="accordion-container">
          {helperModalTexts.map((i, idx) => {
            return <Item key={idx} item={i} />
          })}
        </div>
        <h2 className="helper-header">Descrição das páginas</h2>
        <div className="accordion-container">
          {helperModalScreens.map((i, idx) => {
            return <Item key={idx} item={i} />
          })}
        </div>
      </div>
      {showHelpModal && <div onClick={toggleHelpModal} className="offcanvas-background" />}


    </div>
  );
};

export default HelpModal;
